export var Permissions;
(function (Permissions) {
    Permissions["AdministrationView"] = "Frends.Administration.View";
    Permissions["ApiKeyManagementAdmin"] = "Frends.ApiKeyManagement.Admin";
    Permissions["ApiManagementView"] = "Frends.ApiManagement.View";
    Permissions["ApiManagementEdit"] = "Frends.ApiManagement.Edit";
    Permissions["ApiManagementDeploy"] = "Frends.ApiManagement.Deploy";
    Permissions["ApiAccessPolicyManagementAdmin"] = "Frends.ApiAccessPolicyManagement.Admin";
    Permissions["EnvironmentEdit"] = "Frends.Environment.Edit";
    Permissions["EnvironmentVariablesEdit"] = "Frends.EnvironmentVariables.Edit";
    Permissions["MonitoringRulesView"] = "Frends.MonitoringRules.View";
    Permissions["ProcessEdit"] = "Frends.Process.Edit";
    Permissions["ProcessStart"] = "Frends.Process.Start";
    Permissions["ProcessDeploy"] = "Frends.Process.Deploy";
    Permissions["ProcessView"] = "Frends.Process.View";
    Permissions["ProcessInstanceEdit"] = "Frends.ProcessInstance.Edit";
    Permissions["SubProcessEdit"] = "Frends.Process.Edit";
    Permissions["TaskView"] = "Frends.Task.View";
    Permissions["UserManagementAdmin"] = "Frends.UserManagement.Admin";
    Permissions["SettingsAdmin"] = "Frends.Settings.Admin";
})(Permissions || (Permissions = {}));
export const AllPermissionsTrue = {
    [Permissions.ApiManagementView]: true,
    [Permissions.ApiManagementEdit]: true,
    [Permissions.ApiManagementDeploy]: true,
    [Permissions.ProcessView]: true,
    [Permissions.ProcessEdit]: true,
    [Permissions.ProcessStart]: true,
    [Permissions.ProcessDeploy]: true,
    [Permissions.EnvironmentVariablesEdit]: true,
    [Permissions.AdministrationView]: true,
    [Permissions.EnvironmentEdit]: true,
    [Permissions.TaskView]: true,
    [Permissions.MonitoringRulesView]: true,
    [Permissions.UserManagementAdmin]: true,
    [Permissions.ApiKeyManagementAdmin]: true,
    [Permissions.ProcessInstanceEdit]: true,
    [Permissions.ApiAccessPolicyManagementAdmin]: true,
    [Permissions.SettingsAdmin]: true
};
